<template>
  <label class="checkbox-container" :class="disabled?'disabled':''">
    <input type="checkbox" v-model="checked" :value="val || value" @change="onChange" :disabled="disabled" />
    <span class="checkmark"></span>
    <span v-if="text" v-html="text" />
  </label>
</template>
<script>
export default {
  name: 'Checkbox',
  props: {
    value: {
      type: [Boolean, Array],
      required: true // taken from v-model
    },
    val: {
      type: [Boolean, String],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      checkedProxy: false
    }
  },
  computed: {
    checked: {
      get() {
        return this.value
      },
      set(val) {
        this.checkedProxy = val
      }
    }
  },
  methods: {
    onChange: function () {
      this.$emit('input', this.checkedProxy)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
/* The container */
.checkbox-container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  &.disabled {
    cursor: not-allowed;
    color: color.adjust($black-color, $lightness: 33%)
  }

  /* Hide the browser's default checkbox */
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #ffffff;
    border: 1px solid #dbdbdb;
    border-radius: 4px;
  }

  /* On mouse-over, add a grey background color */
  :hover input ~ .checkmark {
    background-color: #dbdbdb88;
  }

  /* When the checkbox is checked, add a background */
  input:checked ~ .checkmark {
    background-color: $primary-color;
    border: 1px solid $primary-color;
  }

  /* Show the checkmark when checked */
  input:checked ~ .checkmark:after {
    display: block;
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
    left: 7px;
    top: 3px;
    width: 4px;
    height: 9px;
    border: solid white;
    border-width: 0 2.5px 2.5px 0;
    transform: rotate(45deg);
  }
}

.shadow {
  .checkmark {
    box-shadow: 0 0 7px 0 rgba(69, 69, 69, 0.2);
  }
}
</style>
